/**
 * Traffic-light indicators for admin list pages.
 *
 * Two rendering modes:
 *   • <TrafficLights lights={...} />        — inline row of dots + tooltips
 *   • <TrafficDot light={l} label="KYC" />  — single dot, used inside its
 *                                             own TableCell column so each
 *                                             signal gets a labelled header.
 */
import React from 'react';

const COLOR_CLASS = {
  green: 'bg-emerald-500',
  amber: 'bg-amber-400',
  red: 'bg-red-500',
  grey: 'bg-slate-300',
};

const LABELS = {
  management_accounts: 'Management A/Cs',
  kyc: 'KYC',
  afs: 'AFS',
  bank_statements: 'Bank statements',
  unresolved_queries: 'Open queries',
};

function tooltip(light, label) {
  const status = light?.status || 'grey';
  const stale = light?.days_stale;
  const count = light?.count;
  return `${label}: ${status}${stale != null ? ` (${stale}d)` : ''}${count != null ? ` (${count} open)` : ''}`;
}

export function TrafficDot({ light, label, testId }) {
  const color = light?.color || 'grey';
  const count = light?.count;
  return (
    <div className="flex items-center justify-center gap-1" title={tooltip(light, label || '')} data-testid={testId}>
      <span className={`inline-block h-2.5 w-2.5 rounded-full ${COLOR_CLASS[color] || COLOR_CLASS.grey}`} />
      {typeof count === 'number' && count > 0 && (
        <span className="text-[10px] font-mono text-slate-600">{count}</span>
      )}
    </div>
  );
}

export function TrafficLights({ lights = {}, testId }) {
  const keys = Object.keys(lights);
  if (keys.length === 0) return null;
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {keys.map((k) => {
        const l = lights[k];
        const label = LABELS[k] || k;
        return (
          <TrafficDot key={k} light={l} label={label} testId={`light-${k}`} />
        );
      })}
    </div>
  );
}

export default TrafficLights;

